module.exports = __webpack_public_path__ + "static/media/new-tab.78235a00.svg";